import { DateTime } from "luxon";

export function isValidDate(date) {
  return DateTime.fromISO(date).isValid;
}

export function dateIsInThePast(date) {
  let now = DateTime.now();
  let dateObj = DateTime.fromISO(date);
  let inThePast = dateObj.startOf("day") < now.startOf("day");
  return inThePast;
}

export function getValidStartDate(date) {
  const valid = isValidDate(date);
  if (!valid) return DateTime.now().toISODate();

  let isPastDate = dateIsInThePast(date);
  if (isPastDate) return DateTime.now().toISODate();

  return date;
}

export function getValidEndDate(date) {
  const valid = isValidDate(date);
  if (!valid) return null;

  let isPastDate = dateIsInThePast(date);
  if (isPastDate) return null;

  return date;
}

export function getValidInterval(interval) {
  let intervals = ["weekly", "monthly", "quarterly", "annually"];

  if (!interval || typeof interval !== "string") return "monthly";
  if (intervals.includes(interval.toLowerCase())) return interval;
  return "monthly";
}
